import { render, staticRenderFns } from "./SmsHistory.vue?vue&type=template&id=31d11df4&scoped=true"
import script from "./SmsHistory.vue?vue&type=script&lang=js"
export * from "./SmsHistory.vue?vue&type=script&lang=js"
import style0 from "./SmsHistory.vue?vue&type=style&index=0&id=31d11df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d11df4",
  null
  
)

export default component.exports